import { render, staticRenderFns } from "./ImportNewFormFrSite.vue?vue&type=template&id=357b2b63"
import script from "./ImportNewFormFrSite.vue?vue&type=script&lang=js"
export * from "./ImportNewFormFrSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports